import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { authAxios } from "../utils";
import { Row, Col, Button, Form, Select, Input } from "antd";
import { ListStatusURL, changeStatusTicketURL } from "../constants";
import Cookies from "universal-cookie";
import { openNotificationWithIcon } from "./Function";

const cookies = new Cookies();

const validateMessages = {
  required: "Vui lòng nhập ${label}",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

class TicketChangeStatus extends React.Component {
  state = {
    loading: false,
    lsStatus: [],
  };

  componentDidMount() {
    this.fetchStatusListAPI();
  }

  fetchStatusListAPI = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(ListStatusURL)
      .then((res) => {
        this.setState({
          lsStatus: res.data.results.filter((item) => item.id !== 1),
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };

  onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("ticket_code", values.ticket_code?.trim());
    data.append("ticket_status_id", values.ticket_status_id);
    data.append("lydohuyyeucau", values.lydohuyyeucau);
    authAxios(cookies.get("token"))
      .post(changeStatusTicketURL, data)
      .then((res) => {
        if (res.data.error != "") {
          openNotificationWithIcon("error", "Thông báo", res.data.error);
          return;
        }
        openNotificationWithIcon("success", "Thông báo", res.data.message);
      })
      .catch((err) => {
        this.setState({ loading: false });
        openNotificationWithIcon("error", "Thông báo", err);
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };

  formLayout = (data) => {
    const [form] = Form.useForm();

    return (
      <Form
        onFinish={this.onFinish}
        form={form}
        style={{ textAlign: "center" }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        validateMessages={validateMessages}
      >
        <Row>
          <Col lg={{ span: 9, offset: 1 }}>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Mã yêu cầu"
                  name="ticket_code"
                  rules={[{ required: true }]}
                >
                  <Input
                    placeholder={`Nhập ticket code`}
                    autoComplete={"off"}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Trạng thái"
                  name="ticket_status_id"
                  rules={[{ required: true }]}
                  initialValue={[]}
                >
                  <Select placeholder="Chọn trạng thái">
                    {data.lsStatus.map((v) => (
                      <Select.Option key={v.id} value={v.id}>
                        {v.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item name="lydohuyyeucau" label="Lý do chuyển trạng thái">
                  <Input placeholder="Nhập lý do chuyển trạng thái" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={{ span: 3, offset: 1 }} className="styleBtnExcel">
            <div className="brace-left">
              <div className="brace-top"></div>
              <div className="brace-bottom"></div>
            </div>
            <Row>
              <Form.Item>
                <Button
                  type={"primary"}
                  className={"btnGreen"}
                  htmlType={"submit"}
                >
                  Cập nhật
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 9, offset: 1 }} style={{ color: "gray" }}>
            Mô tả chức năng: <br></br>- Thay đổi trạng thái ticket và lưu lịch
            sử thay đổi <br></br>- Không gửi mail khi chuyển trạng thái
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return (
      <>
        <this.formLayout {...this.state} />
      </>
    );
  }
}

export default withRouter(connect()(TicketChangeStatus));
